import {EditorState} from 'draft-js'
import * as RasaChromePicker from '../../../components/chrome-picker'
import * as Form from '../../../components/form'
import * as RasaInput from '../../../components/rasa-input'
import * as LeadTextTypes from '../types'
import * as Types from './types'

export const ADD_LEAD_TEXT_MODAL = 'ADD_LEAD_TEXT_MODAL'
export const POST_LEAD_TEXT = 'POST_LEAD_TEXT'
export const PUT_LEAD_TEXT = 'PUT_LEAD_TEXT'
export const FormConstants = Form.createConstantsMap(ADD_LEAD_TEXT_MODAL)

export const FieldNames = {
  CommunityPartnerCode: 'community_partner_code',
  Description: 'description',
  EditorState: 'editor_state',
  EndDate: 'end_date',
  IsActive: 'is_active',
  StartDate: 'start_date',
  Styles: 'styles',
  Title: 'title',
}

export const FormValidators: Form.FormValidators = {
  [FieldNames.Description]: RasaInput.validateTitle,
}

type Border = string
type Padding = string
type Block = string
type Inline = string
type ToolbarOption = string

export const borderSizes: Border[] = ['0px', '0.25px', '0.5px', '0.75px', '1px', '2px', '3px', '4px', '5px', '10px']
export const paddingSizes: Padding[] = ['0px', '5px', '10px', '15px', '20px', '25px']
export const blockTypeOptions: Block[] = ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']
export const inlineOptions: Inline[] =
  ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript']
export const toolbarOptions: ToolbarOption[] =
  ['image', 'inline', 'blockType', 'colorPicker', 'fontSize', 'fontFamily', 'link', 'textAlign']

interface LinkCallbackObject {
  target: string,
  targetOption: string,
  title: string,
}

// Do nothing callback.  Default callback validates a URL
// which prevents using the tokenization keys -- __FEEDBACK_URL__ for example.
const linkCallbackFn = (l: LinkCallbackObject): LinkCallbackObject => l

export const toolbarObject = {
  blockType: { options: blockTypeOptions },
  inline: { options: inlineOptions },
  link: { linkCallback: linkCallbackFn },
  options: toolbarOptions,
}

export const BORDER = 'BORDER'
export const BORDER_SIZE = `${BORDER}_SIZE`
export const BACKGROUND = 'BACKGROUND'
export const PADDING_SIZE = 'PADDING_SIZE'

export const END_DATE = 'end_date'
export const START_DATE = 'start_date'

export const GUI_EDITOR = 'GUI'
export const RAW_EDITOR = 'RAW'

export const LEAD_TEXT_BACKGROUND_COLOR_CHANGE = 'LEAD_TEXT_BACKGROUND_COLOR_CHANGE'
export const LEAD_TEXT_BORDER_COLOR_CHANGE = 'LEAD_TEXT_BORDER_COLOR_CHANGE'
export const LEAD_TEXT_BORDER_SIZE_CHANGE = 'LEAD_TEXT_BORDER_SIZE_CHANGE'
export const LEAD_TEXT_PADDING_SIZE_CHANGE = 'LEAD_TEXT_PADDING_SIZE_CHANGE'

export const ADD_LEAD_TEXT_MODAL_ENTER = 'ADD_LEAD_TEXT_MODAL_ENTER'
export const UPDATE_EDITOR_STATE = 'UPDATE_EDITOR_STATE'

export const emptyStyleObject: LeadTextTypes.StyleObject = {
  background: RasaChromePicker.DEFAULT_COLOR,
  border: 'none',
  padding: '0px',
}
export const emptyBorderObject: LeadTextTypes.Border = {
  color: RasaChromePicker.DEFAULT_COLOR,
  lineType: 'solid',
  size: '1px',
}

export const emptyEditorState: Types.EditorState = {
  border: emptyBorderObject,
  editorState: EditorState.createEmpty(),
  styleObject: emptyStyleObject,
}

export const emptySelectedLeadText: any = {
  description: '',
  end_date: null,
  start_date: null,
  styles: '',
  title: '',
}

export const EDIT = 'Edit'



// WEBPACK FOOTER //
// ./src/pages/lead-text/add-edit-modal/constants.ts